import { ClassAttributes, ButtonHTMLAttributes } from 'react';
import AppleSignin from 'react-apple-signin-auth';
import { JSX } from 'react/jsx-runtime';
import { AppleLogin } from '../../assets';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import { SocialLoginButtonsProps, SocialLoginPlatformEnum } from './type';
import { t } from 'i18next';

export default function AppleLoginBtn({ afterSocialLoginSuccess, dataSocial }: SocialLoginButtonsProps) {
  const navigate = useNavigate();
  return (
    <div data-social={dataSocial}>
      <AppleSignin
        /** Auth options passed to AppleID.auth.init() */
        authOptions={{
          /** Client ID - eg: 'com.example.com' */
          clientId: `${process.env.REACT_APP_APPLE_CLIENT_ID}`,
          /** Requested scopes, seperated by spaces - eg: 'email name' */
          scope: 'email name',
          /** Apple's redirectURI - must be one of the URIs you added to the serviceID - the undocumented trick in apple docs is that you should call auth from a page that is listed as a redirectURI, localhost fails */
          redirectURI: `${process.env.REACT_APP_APPLE_REDIRECT_URL}`,
          /** State string that is returned with the apple response */
          state: 'state',
          /** Nonce */
          nonce: 'nonce',
          /** Uses popup auth instead of redirection */
          usePopup: true,
        }} // REQUIRED
        /** General props */
        uiType="dark"
        /** className */
        className="apple-auth-btn"
        /** Removes default style tag */
        noDefaultStyle={false}
        /** Allows to change the button's children, eg: for changing the button text */
        buttonExtraChildren="Continue with Apple"
        /** Extra controlling props */
        /** Called upon signin success in case authOptions.usePopup = true -- which means auth is handled client side */
        onSuccess={(response: any) => {
          const { authorization } = response;
          const { id_token, code } = authorization;
          const decodedToken = jwtDecode<any>(id_token);
          const { sub, email } = decodedToken;
          afterSocialLoginSuccess({
            type: SocialLoginPlatformEnum.APPLE,
            socialId: sub,
            email: email,
          });
        }} // default = undefined
        /** Called upon signin error */
        onError={(error: any) => {
          console.error('애플 로그인 실패', error);
          navigate('/auth', { replace: true });
        }} // default = undefined
        /** Skips loading the apple script if true */
        skipScript={false} // default = undefined
        /** Apple image props */

        /** render function - called with all props - can be used to fully customize the UI by rendering your own component  */
        render={(
          props: JSX.IntrinsicAttributes & ClassAttributes<HTMLButtonElement> & ButtonHTMLAttributes<HTMLButtonElement>
        ) => (
          <button 
            {...props} 
            className="flex items-center justify-center bg-black md:w-[357px] md:h-[54px] md:rounded-full md:px-7 md:pb-0
              w-[48px] h-[48px] rounded-[8px] pb-[2px]"
          >
            <AppleLogin className='hidden md:block' width={24} height={24} />
            <AppleLogin className='block md:hidden' />
            <span className={`hidden md:block px-5 text-white text-[16px] font-medium font-weight-600 leading-[150%]`}>
              {t("login.apple")}
            </span>
          </button>
        )}
      />
    </div>
  );
}
